import { h } from 'preact';
import React, { Component } from 'react';
import Accordion from '../Components/Accordion';
import StackToggle from '../Stacks/StackToggle';
import { makeText, formatDescription } from '../../../util';

const FeatureList = ({
  featuresInfo,
  features,
  settings,
  force,
  updateMe,
  accordionOpen,
}) => {
  return (
    <div className="features-list">
      <p style="margin-bottom:15px;">{formatDescription(featuresInfo)}</p>
      {features.map(f => (
        <StackToggle
          key={f._id}
          purpose={f}
          selected="vendors"
          settings={settings}
          force={force}
          updateMe={updateMe}
          parentAccordionOpen={accordionOpen}
          isFeature
        />
      ))}
    </div>
  );
}

export default class Features extends Component {
  render() {
    const {
      features,
      settings,
      language,
      force,
      updateMe,
      dev,
      usePurModel,
    } = this.props;

    const featuresText = makeText(Boolean(dev), settings, 'featuresText', language);
    const featuresInfo = makeText(Boolean(dev), settings, 'featuresInfo', language);
    return (
      <Accordion
        settings={settings}
        name={featuresText}
        child="features"
        language={language}
        value={null}
        force={force}
        description={null}
        content={<FeatureList featuresInfo={featuresInfo} features={features} settings={settings} language={language} force={force} updateMe={updateMe} />}
        usePurModel={usePurModel}
      />
    );
  }
}
